import { useState } from "react";

export default function CreateBlog() {
  const API_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/blogs`;

  const [form, setForm] = useState({
    title: "",
    content: "",
    tags: "",
    author: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const res = await fetch(API_BASE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...form,
          tags: form.tags.split(",").map(t => t.trim()),
        }),
      });

      await res.json();
      alert("✅ Blog published!");
      setForm({ title: "", content: "", tags: "", author: "" });
    } catch (err) {
      alert("❌ Error creating blog");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">

      {/* LEFT → FORM */}
      <div className="w-1/2 p-8 border-r bg-white">

        <h1 className="text-2xl font-bold mb-6">✍️ Create Blog</h1>

        {/* Title */}
        <input
          placeholder="Enter blog title..."
          className="w-full text-2xl font-semibold border-b mb-6 outline-none"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />

        {/* Author */}
        <input
          placeholder="Author name"
          className="w-full border p-3 rounded-lg mb-4"
          value={form.author}
          onChange={(e) => setForm({ ...form, author: e.target.value })}
        />

        {/* Tags */}
        <input
          placeholder="Tags (comma separated)"
          className="w-full border p-3 rounded-lg mb-4"
          value={form.tags}
          onChange={(e) => setForm({ ...form, tags: e.target.value })}
        />

        {/* Content */}
        <textarea
          placeholder="Write your blog content (HTML supported)..."
          className="w-full border p-4 rounded-lg h-72 resize-none"
          value={form.content}
          onChange={(e) => setForm({ ...form, content: e.target.value })}
        />

        {/* Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="mt-6 px-6 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium hover:opacity-90 transition"
        >
          {loading ? "Publishing..." : "Publish Blog 🚀"}
        </button>
      </div>

      {/* RIGHT → LIVE PREVIEW */}
      <div className="w-1/2 p-8 overflow-y-auto">

        <h2 className="text-xl font-semibold mb-4 text-gray-700">
          Live Preview
        </h2>

        <div className="bg-white p-6 rounded-xl border shadow-sm">

          {/* Title */}
          <h1 className="text-3xl font-bold mb-3 text-gray-900">
            {form.title || "Your blog title..."}
          </h1>

          {/* Author */}
          <div className="text-sm text-gray-500 mb-4">
            {form.author || "Author"} • Preview
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-4">
            {form.tags.split(",").map((tag, i) =>
              tag.trim() ? (
                <span
                  key={i}
                  className="bg-gray-100 px-2 py-1 text-xs rounded"
                >
                  #{tag.trim()}
                </span>
              ) : null
            )}
          </div>

          {/* Content */}
          <div
            className="prose max-w-none text-gray-800"
            dangerouslySetInnerHTML={{
              __html: form.content || "<p>Start writing your blog...</p>",
            }}
          />
        </div>
      </div>

    </div>
  );
}